var render, staticRenderFns
import script from "./ColorTypeInvoiceByClient.vue?vue&type=script&lang=js&"
export * from "./ColorTypeInvoiceByClient.vue?vue&type=script&lang=js&"
import style0 from "./ColorTypeInvoiceByClient.vue?vue&type=style&index=0&id=4854a7a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854a7a8",
  null
  
)

export default component.exports